import { useContext } from "react";

import { OtpContext } from "./OtpProvider";

export function useOtp() {
  const context = useContext(OtpContext);
  if (!context) {
    throw new Error("useOtp must be used within an OtpProvider");
  }
  return context;
}
